import React from 'react';
import { Link } from 'react-router-dom';

import './agreementCell.scss';

const AgreementCell = (props) => {
  return (
    <td className='agreementCell'>
      <Link to={`${props.dataItem.id}`}>
        <p>{props.dataItem.name}</p>
      </Link>
    </td>
  );
};

export default AgreementCell;
